function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-7.008 -19.504)"
}, React.createElement("path", {
  d: "M277.952,101.179,276.938,97.5l-5.93,1.668.947,3.675Z",
  transform: "translate(-258.048 -76.241)"
}), React.createElement("path", {
  d: "M12.4,28.9v0l.969-.293L11.021,19.5H7.008v1.285h2.9l2.045,8.247Z",
  transform: "translate(0 0)"
}), React.createElement("path", {
  d: "M475.971,475.006l-.121-.51-6.185,1.721.478,1.5,6.09-1.774-.225-.947Z",
  transform: "translate(-452.225 -444.734)"
}), React.createElement("path", {
  d: "M159.738,450.023l.44-.44-.8-.8-.44.44a2.805,2.805,0,0,0-.847-.375v-.658h-1.416v.658a2.8,2.8,0,0,0-.864.386l-.422-.422-.8.8.429.429a2.807,2.807,0,0,0-.365.829H154v1.416h.657a2.809,2.809,0,0,0,.376.848l-.44.44.8.8.44-.44a2.8,2.8,0,0,0,.85.376v.657h1.411v-.657a2.807,2.807,0,0,0,.832-.365l.457.457.8-.8-.451-.451a2.792,2.792,0,0,0,.387-.869h.657v-1.406h-.657A2.794,2.794,0,0,0,159.738,450.023Zm-2.352,2.715a1.161,1.161,0,1,1,1.161-1.161A1.16,1.16,0,0,1,157.386,452.738Z",
  transform: "translate(-143.678 -419.023)"
}), React.createElement("path", {
  d: "M323.455,260.669a2.223,2.223,0,0,1,2.157.732l.008.008.03.034a1.974,1.974,0,0,1,.247.438l.06.189,6.927-1.913-.992-3.675-8.883,2.435Z",
  transform: "translate(-308.875 -231.633)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 16.436,
    viewBox: "0 0 17 16.436"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/stock-alert.37895719.svg";
export { SvgComponent as ReactComponent };